import axios from 'axios';
import { uploadDocument, uploadImage } from '../utils/upload';
import { Prod01 } from '../constants/ActionType';
import moment from 'moment';

import {
    HR_PATIENTS_REQUEST,
    HR_PATIENTS_SUCCESS,
    HR_PATIENTS_FAIL,
    ADDING_COMMENT_REQUEST,
    ADDING_COMMENT_SUCCESS,
    ADDING_COMMENT_FAIL,
    ADDING_TIME_SPENT_SUCCESS,
    ADDING_TIME_SPENT_FAIL,
    TIME_REPORT_REQUEST,
    TIME_REPORT_SUCCESS,
    TIME_REPORT_FAIL,
    TARGETED_MINUTES_REQUEST,
    TARGETED_MINUTES_SUCCESS,
    TARGETED_MINUTES_FAIL,
    INITIAL_MONTH_REPORT_REQUEST,
    INITIAL_MONTH_REPORT_SUCCESS,
    INITIAL_MONTH_REPORT_FAIL,
    ADDING_CARE_PLAN_SUCCESS,
    ADDING_CARE_PLAN_FAIL,
    PATIENT_CARE_PLAN_SUCCESS,
    PATIENT_CARE_PLAN_FAIL,
    UPDATE_CARE_PLAN_SUCCESS,
    UPDATE_CARE_PLAN_FAIL,
    TIME_SPENT_OF_CURRENT_MONTH_SUCCESS,
    TIME_SPENT_OF_CURRENT_MONTH_FAIL,
    GET_HR_NOTIFICATIONS_REQUEST,
    GET_HR_NOTIFICATIONS_SUCCESS,
    GET_HR_NOTIFICATIONS_FAIL,
    GET_CAREPLAN_LIST_REQUEST,
    GET_CAREPLAN_LIST_SUCCESS,
    GET_CAREPLAN_LIST_FAIL,
    HR_STATS_SUCCESS,
    HR_STATS_FAIL,
    TIME_SPENT_OF_CURRENT_MONTH_IN_CCM_SUCCESS,
    TIME_SPENT_OF_CURRENT_MONTH_IN_CCM_FAIL,
    CLEAR_ERRORS,
    GET_CCM_CONSENT_REQUEST,
    GET_CCM_CONSENT_SUCCESS,
    GET_CCM_CAREPLAN_REQUEST,
    GET_CCM_CAREPLAN_SUCCESS,
    CHAT_PATIENT_REQUEST,
    CHAT_PATIENT_SUCCESS,
    CHAT_PATIENT_FAIL
} from '../constants/HRConstants';

import { 
    RECENT_READINGS_SUCCESS
} from '../constants/adminConstants';

import { 
    SHOW_ALERT_MESSAGE,
    HIDE_ALERT_MESSAGE,
    FETCH_ERROR
} from '../constants/Common';
import { sortQuery } from '../components/SortableTable';



export const getHRPatients = (drId, includeDeactivated = false) => async (dispatch) => {
    try {
        dispatch({
            type: HR_PATIENTS_REQUEST,
        })


        const { data } = await axios.post(`${Prod01}/hr/patientlist/${drId}`, {
            name: 'hammad',
            includeDeactivated
        });

        dispatch({
            type: HR_PATIENTS_SUCCESS,
            payload: data
        })


    } catch (error) {
        dispatch({
            type: HR_PATIENTS_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}

export const getPatientChat = (PatientId, id) => async (dispatch) => {
    try {
        dispatch({
            type: CHAT_PATIENT_REQUEST,
        })


        const { data } = await axios.post(`${Prod01}/general/getMessages`, {
            patientId: PatientId, 
            nurseId: id
        });

        dispatch({
            type: CHAT_PATIENT_SUCCESS,
            payload: data
        })


    } catch (error) {
        dispatch({
            type: CHAT_PATIENT_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}


export const changePassword = (id, oldPassword, newPassword) => async(dispatch) => {
    try {
        
    await axios.put(`${Prod01}/hr/changePassword/${id}`, {
        oldPassword: oldPassword,
        password: newPassword
    });

    dispatch({
        type: SHOW_ALERT_MESSAGE,
        payload: "Password Updated"
    });
        
    dispatch({
        type: HIDE_ALERT_MESSAGE
    }) 
    

    } catch (error) {
        dispatch({
            type: FETCH_ERROR,
            payload: error?.response?.data?.message || error.message
        })
    }
}


export const submitPatientChat = (PatientId, nurseId, message) => async (dispatch) => {
    try {
        const { data } = await axios.post(`${Prod01}/general/sendMessage`, {
            patient_id: PatientId, 
            nurse_id: nurseId,
            message: message
        });

        dispatch({
            type: SHOW_ALERT_MESSAGE,
            payload: "Message Sent"
            });
        
        dispatch({
            type: HIDE_ALERT_MESSAGE
        })     

        dispatch(getPatientChat(PatientId, nurseId));


    } catch (error) {
        dispatch({
            type: FETCH_ERROR,
            payload: 'Server Error! Cannot send message'
          })
        dispatch({
            type: HIDE_ALERT_MESSAGE
          })
    }
}


export const getHRCCMPatients = (doctorId, resPerPage, currentPage, sort = null) => async (dispatch) => {
    
    if(doctorId !== 'undefined'){
        try {
            dispatch({
                type: HR_PATIENTS_REQUEST,
            })
    
            const { data } = await axios.post(`${Prod01}/general/ccmpatients/list/${resPerPage}/${currentPage}${sort && sort.sortBy ? `?${sortQuery(sort.sortBy, sort.sortDir)}` : ''}`, {
                drId: doctorId
            });
    
            dispatch({
                type: HR_PATIENTS_SUCCESS,
                payload: data
            })
    
    
        } catch (error) {
            dispatch({
                type: HR_PATIENTS_FAIL,
                payload: error?.response?.data?.message || error.message
            })
        }
    }
}

export const searchNurseCCMPatients = (doctorId, searchBy, keyword) => async (dispatch) => {
    try {
        dispatch({
            type: HR_PATIENTS_REQUEST,
        })

        const { data } = await axios.post(`${Prod01}/patient/ccm/search`,{
            key: searchBy,
            value:keyword,
            drId: doctorId
        }, );

        dispatch({
            type: HR_PATIENTS_SUCCESS,
            payload: data
        })
    } catch (error) {
        dispatch({
            type: HR_PATIENTS_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}


export const getHRStats = (id) => async (dispatch) => {
    try {
        const { data } = await axios.post(`${Prod01}/hr/hrStats`, {
            hrId: id
        });

        dispatch({
            type: HR_STATS_SUCCESS,
            payload: data
        })


    } catch (error) {
        dispatch({
            type: HR_STATS_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}



export const getNursePtsRecentReadings = (drId) => async (dispatch) => {
    try {
        const { data } = await axios.post(`${Prod01}/hr/recentReadings`, {
            drId: drId
        });

        dispatch({
            type: RECENT_READINGS_SUCCESS,
            payload: data
        });


    } catch (error) {
        
    }
}



// HR comment on reading
export const commentOnReading = (readingId, hrId, comment, patientId, notes) => async (dispatch) => {

    try {
        dispatch({
            type: ADDING_COMMENT_REQUEST
        });

        const { data } = await axios.put(`${Prod01}/patient/commentonreading/${readingId}`, {
            conclusion_hr_id: hrId,
            conclusion: comment
        });

        dispatch({
            type: ADDING_COMMENT_SUCCESS,
            payload: data
        });

        await axios.post(`${Prod01}/hr/addtimeforpatient/${hrId}`, {
            assigned_patient_id: patientId,
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            startTime: moment().tz("America/New_York").format("HH:mm"),
            endTime: moment().tz("America/New_York").add(1, 'minutes').format("HH:mm"),
            interactiveMinutes: true,
            timeSpentInMinutes: 1,
            conclusion: notes
        });

    } catch (error) {
        dispatch({
            type: ADDING_COMMENT_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}

export const commentOnReadingByStaff = (readingId, staffId, comment) => async (dispatch) => {

    try {
        dispatch({
            type: ADDING_COMMENT_REQUEST
        });

        const { data } = await axios.put(`${Prod01}/patient/commentonreading/${readingId}`, {
            conclusion_doctor_id: staffId,
            conclusion: comment
        });

        dispatch({
            type: ADDING_COMMENT_SUCCESS,
            payload: data
        });

    } catch (error) {
        dispatch({
            type: ADDING_COMMENT_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}

// Time Spent on Patient
// `program` must be declared explicitly (CCM | PCM | RPM | APCM) - the backend rejects entries without one (400).
export const timeSpentOnPatient = (patientId, hrId, startDate, endDate, startTime, endTime, program, interactiveMinutes, minutes, note, fileName) => async (dispatch) => {
    let data = {};
    try {
        const uploaded = await uploadDocument(fileName);

        data = await axios.post(`${Prod01}/hr/addtimeforpatient/${hrId}`, {
            assigned_patient_id: patientId,
            startDate: startDate,
            endDate: endDate,
            startTime: startTime,
            endTime: endTime,
            program,
            isCCM: program === 'CCM',
            interactiveMinutes: interactiveMinutes,
            timeSpentInMinutes: minutes,
            conclusion: note,
            fileName: uploaded.filename,
            originalFileName: uploaded.originalName
        });


        dispatch({
            type: ADDING_TIME_SPENT_SUCCESS,
            payload: data
        });
        return data?.data;
    } 
   
    catch (error) {
        dispatch({
            type: ADDING_TIME_SPENT_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}

export const timeSpentOnPatientAuto = (patientId, hrId, minutes, description, program) => async(dispatch) => {
    try {
       const { data } = await axios.post(`${Prod01}/hr/addtimeforpatient/${hrId}`, {
                assigned_patient_id : patientId,
                timeSpentInMinutes:minutes,
                conclusion: description,
                program,
                isCCM: program === 'CCM'
           });    
           
        dispatch({ 
            type: ADDING_TIME_SPENT_SUCCESS,
            payload: data
        });
        
    } catch (error) {
       dispatch({
           type: ADDING_TIME_SPENT_FAIL,
           payload: error.message
       })
    }   
}


export const carePlanOfPatient = (patientId, hrId, description, readingsPerMonth, readingsInDay, readingsInNight, fileName) => async (dispatch) => {
    let data;
    try {
    
        const uploaded = await uploadDocument(fileName);
        data = await axios.post(`${Prod01}/patient/addCarePlan`, {
            assigned_hr_id: hrId,
            assigned_patient_id: patientId,
            Description: description,
            readingsPerMonth: readingsPerMonth,
            readingsInSlot1: readingsInDay,
            readingsInSlot2: readingsInNight,
            fileName: uploaded.filename,
            originalFileName: uploaded.originalName
        });

        dispatch({
            type: ADDING_CARE_PLAN_SUCCESS,
            payload: data
        });

    } catch (error) {
        dispatch({
            type: ADDING_CARE_PLAN_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}

export const getTimeReport = (patientId, month, year) => async (dispatch) => {
    try {
        dispatch({
            type: TIME_REPORT_REQUEST
        });

        const { data } = await axios.post(`${Prod01}/hr/listtargets&totaltime`, {
            patientId: patientId,
            month: month,
            year: year
        });

        dispatch({
            type: TIME_REPORT_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: TIME_REPORT_FAIL,
            payload: error.message
        })
    }
}

export const getPatientRPMTargetedMinutes = (patientId, month, year) => async (dispatch) => {
    try {
        dispatch({
            type: TARGETED_MINUTES_REQUEST
        });

        const { data } = await axios.post(`${Prod01}/hr/listtargets&totaltime`, {
            patientId: patientId,
            month: month,
            year: year
        });

        dispatch({
            type: TARGETED_MINUTES_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: TARGETED_MINUTES_FAIL,
            payload: error.message
        })
    }
}

export const getTimeReportByHR = (hrId, month, year) => async (dispatch) => {
    try {
        dispatch({
            type: TIME_REPORT_REQUEST
        });

        const { data } = await axios.post(`${Prod01}/hr/listtargets&totaltime`, {
            hrId: hrId,
            month: month,
            year: year
        });

        dispatch({
            type: TIME_REPORT_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: TIME_REPORT_FAIL,
            payload: error.message
        })
    }
}

export const getTimeReportByDR = (drId, month, year) => async (dispatch) => {
    try {
        dispatch({
            type: TIME_REPORT_REQUEST
        });

        const { data } = await axios.post(`${Prod01}/hr/listtargets&totaltimeOfDoctor`, {
            drId: drId,
            month: month,
            year: year
        });

        dispatch({
            type: TIME_REPORT_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: TIME_REPORT_FAIL,
            payload: error.message
        })
    }
}

export const getTimeReportCCM = (patientId, month, year) => async (dispatch) => {
    try {
        dispatch({
            type: TIME_REPORT_REQUEST
        });

        const { data } = await axios.post(`${Prod01}/hr/listtargets&totaltimeofCCMCategory`, {
            patientId: patientId,
            month: month,
            year: year
        });

        dispatch({
            type: TIME_REPORT_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: TIME_REPORT_FAIL,
            payload: error.message
        })
    }
}

export const getTimeReportCCMByHR = (hrId, month, year, range) => async (dispatch) => {
    try {
        dispatch({
            type: TIME_REPORT_REQUEST
        });

        const { data } = await axios.post(`${Prod01}/hr/listtargets&totaltimeofCCMCategory`, {
            hrId: hrId,
            month: month,
            year: year,
            ...(range ? { startDate: range.startDate, endDate: range.endDate } : {})
        });

        dispatch({
            type: TIME_REPORT_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: TIME_REPORT_FAIL,
            payload: error.message
        })
    }
}


export const getTimeReportCCMByPatient = (patientId, month, year) => async (dispatch) => {
    try {
        dispatch({
            type: TIME_REPORT_REQUEST
        });

        const { data } = await axios.post(`${Prod01}/hr/listtargets&totaltimeofCCMCategory`, {
            patientId: patientId,
            month: month,
            year: year
        });

        dispatch({
            type: TIME_REPORT_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: TIME_REPORT_FAIL,
            payload: error.message
        })
    }
}


export const getTimeReportCCMByDR = (drId, month, year) => async (dispatch) => {
    try {
        dispatch({
            type: TIME_REPORT_REQUEST
        });

        const { data } = await axios.post(`${Prod01}/hr/listtargets&totaltimeOfDoctor`, {
            drId: drId,
            month: month,
            year: year,
            isCCM: true
        });

        dispatch({
            type: TIME_REPORT_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: TIME_REPORT_FAIL,
            payload: error.message
        })
    }
}


export const hrTimeSpentOfCurrentMonth = (patientId, hrId, startDate, endDate) => async (dispatch) => {
    try {

        const { data } = await axios.post(`${Prod01}/hr/listtargets&totaltime`, {
            hrId: hrId,
            patientId: patientId,
            startDate: startDate,
            endDate: endDate
        });

        dispatch({
            type: TIME_SPENT_OF_CURRENT_MONTH_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: TIME_SPENT_OF_CURRENT_MONTH_FAIL,
            payload: error.message
        })
    }
}

export const hrTimeSpentOfCurrentMonthinCCMCategory = (patientId, hrId, startDate, endDate) => async (dispatch) => {
    try {

        const { data } = await axios.post(`${Prod01}/hr/listtargets&totaltimeofCCMCategory`, {
            hrId: hrId,
            patientId: patientId,
            startDate: startDate,
            endDate: endDate
        });

        dispatch({
            type: TIME_SPENT_OF_CURRENT_MONTH_IN_CCM_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: TIME_SPENT_OF_CURRENT_MONTH_IN_CCM_FAIL,
            payload: error.message
        })
    }
}

export const getInitialMonthReport = (doctorId, month, year) => async (dispatch) => {
    try {
        dispatch({
            type: INITIAL_MONTH_REPORT_REQUEST
        });

        let data;

        if (month) {
            data = await axios.post(`${Prod01}/general/report/initialsetup`, {
                month: month+"/"+year
            });
        }

        // if (month && hrId) {
        //     data = await axios.post(`${Prod01}/general/report/initialsetup`, {
        //         month: month+"/"+year,
        //         hrId: hrId
        //     });
        // }

        if (month && doctorId) {
            data = await axios.post(`${Prod01}/general/report/initialsetup`, {
                month: month+"/"+year,
                doctorId: doctorId
            });
        }


        dispatch({
            type: INITIAL_MONTH_REPORT_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: INITIAL_MONTH_REPORT_FAIL,
            payload: error.message
        })
    }
}

export const getPatientCarePlan = (patientId) => async (dispatch) => {
    if (!patientId) return;
    try {

        const data = await axios.get(`${Prod01}/patient/CarePlan/${patientId}`);
        if (!data?.data) {
            dispatch({ type: PATIENT_CARE_PLAN_FAIL, payload: null });
            return;
        }

        dispatch({
            type: PATIENT_CARE_PLAN_SUCCESS,
            payload: data,
        });


    } catch (error) {
        dispatch({
            type: PATIENT_CARE_PLAN_FAIL,
            payload: error.message
        })
    }
}

export const getHRCareplans = (hrId) => async (dispatch) => {
    try {

        dispatch({
            type: GET_CAREPLAN_LIST_REQUEST
        })

        const { data } = await axios.post(`${Prod01}/patient/CarePlanbydrhr`, {
            "hr_Id": hrId
        });

        dispatch({
            type: GET_CAREPLAN_LIST_SUCCESS,
            payload: data,
        });


    } catch (error) {
        dispatch({
            type: GET_CAREPLAN_LIST_FAIL,
            payload: error.message
        })
    }
}

export const updateCarePan = (description, readingsPerMonth, readingsPerDay, careplanId) => async (dispatch) => {
    try {
        const { data } = await axios.put(`${Prod01}/patient/editcareplan/${careplanId}`, {
            Description: description,
            readingsPerMonth: readingsPerMonth,
            readingsPerDay: readingsPerDay
        });

        dispatch({
            type: UPDATE_CARE_PLAN_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: UPDATE_CARE_PLAN_FAIL,
            payload: error.message
        })
    }
}

export const getHRNotifications = (id) => async (dispatch) => {
    try {
        dispatch({ type: GET_HR_NOTIFICATIONS_REQUEST })

        const data = await axios.post(`${Prod01}/general/notifications`, {
            hrId: id, limit: 50
        });

        dispatch({
            type: GET_HR_NOTIFICATIONS_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: GET_HR_NOTIFICATIONS_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}

// Clear errors
export const clearErrors = () => async (dispatch) => {
    dispatch({
        type: CLEAR_ERRORS,
    })
}

export const submitCCMConsent = (fileName, user, patientId, type, description) => async(dispatch) => {
    try { 
            const uploaded = await uploadDocument(fileName);

        await axios.post(`${Prod01}/patient/add/CCMConsent`,{
            assigned_patient_id: patientId,
            addedBy: user?.firstname ? user?.firstname +' '+ user?.lastname : user?.name,
            fileName: uploaded.filename,
            originalFileName: uploaded.originalName,
            assigned_hr_id: user?._id,
            type: type,
            consentType: 'CCM',
            description: type === "Verbal" ? description : null   
        }, );

        dispatch({
            type: SHOW_ALERT_MESSAGE,
            payload: "CCM Consent Added"
            });
        
        dispatch({
            type: HIDE_ALERT_MESSAGE
        })        
    } catch (error) {
        dispatch({
            type: FETCH_ERROR,
            payload: `Unable to add consent: ${error?.response?.data?.message || error.message}`
          })
        dispatch({
            type: HIDE_ALERT_MESSAGE
          })
    }
}

export const submitRPMConsent = (fileName, user, patientId, type, description) => async(dispatch) => {
    try { 
            const uploaded = await uploadDocument(fileName);

        await axios.post(`${Prod01}/patient/add/CCMConsent`,{
            assigned_patient_id: patientId,
            addedBy: user?.firstname ? user?.firstname +' '+ user?.lastname : user?.name,
            fileName: uploaded.filename,
            originalFileName: uploaded.originalName,
            assigned_hr_id: user?._id,
            type: type,
            consentType: 'RPM',
            description: type === "Verbal" ? description : null   
        }, );

        dispatch({
            type: SHOW_ALERT_MESSAGE,
            payload: "RPM Consent Added"
            });
        
        dispatch({
            type: HIDE_ALERT_MESSAGE
        })        
    } catch (error) {
        dispatch({
            type: FETCH_ERROR,
            payload: `Unable to add RPM consent: ${error?.response?.data?.message || error.message}`
          })
        dispatch({
            type: HIDE_ALERT_MESSAGE
          })
    }
}


export const submitCCMCareplan = (fileName, user, patientId, description) => async(dispatch) => {
    try { 
            const uploaded = await uploadDocument(fileName);

        await axios.post(`${Prod01}/patient/add/CCMCarePlan`,{
            assigned_patient_id: patientId,
            addedBy: user?.firstname ? user?.firstname +' '+ user?.lastname : user?.name,
            fileName: uploaded.filename,
            originalFileName: uploaded.originalName,
            description: description
        }, );

        dispatch({
            type: SHOW_ALERT_MESSAGE,
            payload: "CCM Careplan Added"
            });
        
        dispatch({
            type: HIDE_ALERT_MESSAGE
        })        
    } catch (error) {
        dispatch({
            type: FETCH_ERROR,
            payload: `Unable to add consent: ${error?.response?.data?.message || error.message}`
          })
        dispatch({
            type: HIDE_ALERT_MESSAGE
          })
    }
}

export const getPatientCCMConsent = (patientId, consentType) => async(dispatch) => {
    if (!patientId || !consentType) return;
    try { 
        dispatch({
            type: GET_CCM_CONSENT_REQUEST
        });

        const {data} = await axios.get(`${Prod01}/patient/get/CCMConsent/${patientId}/${consentType}`);

        dispatch({
            type: GET_CCM_CONSENT_SUCCESS,
            payload: data
        })

    } catch (error) {
        return
        // dispatch({
        //     type: FETCH_ERROR,
        //     payload: error.message
        // })
    }
}

export const getPatientCCMCareplan = (patientId) => async(dispatch) => {
    if (!patientId) return;
    try { 
        dispatch({
            type: GET_CCM_CAREPLAN_REQUEST
        });

        const {data} = await axios.get(`${Prod01}/patient/get/CCMCarePlan/${patientId}`);

        dispatch({
            type: GET_CCM_CAREPLAN_SUCCESS,
            payload: data
        })

    } catch (error) {
        return
    }
}

export const deleteCCMCareplan = (careplanId) => async(dispatch) => {
    try { 
        await axios.delete(`${Prod01}/patient/remove/CCMCarePlan/${careplanId}`);

        dispatch({
            type: SHOW_ALERT_MESSAGE,
            payload: "CCM Careplan Deleted"
            });
        
        dispatch({
            type: HIDE_ALERT_MESSAGE
        })        
    } catch (error) {
        dispatch({
            type: FETCH_ERROR,
            payload: 'Unable to delete CCM Careplan'
          })
        dispatch({
            type: HIDE_ALERT_MESSAGE
          })
    }
}

export const deleteCCMConsent = (consentId) => async(dispatch) => {
    try { 
        await axios.delete(`${Prod01}/patient/delete/CCMConsent/${consentId}`);

        dispatch({
            type: SHOW_ALERT_MESSAGE,
            payload: "CCM Consent Deleted"
            });
        
        dispatch({
            type: HIDE_ALERT_MESSAGE
        })        
    } catch (error) {
        dispatch({
            type: FETCH_ERROR,
            payload: 'Unable to delete CCM Consent'
          })
        dispatch({
            type: HIDE_ALERT_MESSAGE
          })
    }
}

export const getAssignedRPMPatients = (hrId, includeDeactivated = false) => async (dispatch) => {
    try {
        dispatch({
            type: HR_PATIENTS_REQUEST,
        })


        const { data } = await axios.post(`${Prod01}/hr/assigned/patientlist/${hrId}`, {
            name: 'hammad',
            includeDeactivated
        });

        dispatch({
            type: HR_PATIENTS_SUCCESS,
            payload: data
        })


    } catch (error) {
        dispatch({
            type: HR_PATIENTS_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}
export const AddProfileImgHR = (image, id) => async () => {
  const { filename } = await uploadImage(image);
  await axios.put(`${Prod01}/hr/edit/${id}`, { profileImg: filename });
  return filename;
};
